import React from 'react';
import { useTheme } from '../../theme/ThemeContext';
import ABHASection from './ABHASection';
import { ADD_ABHA_MODAL_TITLE } from '../../constants/abdmCopy';

/**
 * AbhaVerifyModal — hosts ABHASection (verify / create) in a modal. Used by the admission surfaces
 * (new patient in InlineRegisterPatientDialog, existing patient in AdmitPatientForm). `patient` is
 * the existing record, or null for a patient that does not exist yet.
 */
export default function AbhaVerifyModal({ patient, mobile = '', initialMode, notice = '', onComplete, onClose }) {
  const { isDark } = useTheme();
  return (
    <div role="dialog" aria-modal="true" aria-label="Verify ABHA" style={{
      position: 'fixed', inset: 0, zIndex: 10001, display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.5)', padding: '1rem', overflowY: 'auto',
    }}>
      <div style={{
        width: '100%', maxWidth: '480px', maxHeight: '90vh', overflowY: 'auto', padding: '1rem 1.1rem 1.25rem',
        background: isDark ? '#1e293b' : '#ffffff', color: isDark ? '#f5f5f7' : '#111827',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : '#cbd5e1'}`, borderRadius: '0.9rem',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
          <span style={{ fontWeight: 700 }}>{ADD_ABHA_MODAL_TITLE}</span>
          <button type="button" onClick={onClose} style={{
            padding: '0.375rem 0.75rem', borderRadius: '0.5rem', cursor: 'pointer', font: 'inherit',
            background: isDark ? '#374151' : '#f3f4f6', color: isDark ? '#f5f5f7' : '#374151',
            border: `1px solid ${isDark ? 'rgba(255,255,255,0.15)' : '#94a3b8'}`,
          }}>Close</button>
        </div>
        {notice && (
          <p data-testid="abha-verify-notice" style={{ margin: '0 0 0.75rem', fontSize: '0.8125rem' }}>{notice}</p>
        )}
        <ABHASection
          patientId={patient?.patient_id || null}
          abhaStatus={patient?.abha_status || 'NOT_LINKED'}
          initialMode={initialMode || undefined}
          defaultOpen
          hideHeader
          patientName={`${patient?.first_name || ''} ${patient?.last_name || ''}`.trim()}
          defaultMobile={mobile}
          abhaResult={null}
          onAbhaComplete={onComplete}
        />
      </div>
    </div>
  );
}
